var _defs, _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1048 1000"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".map_svg__cls-2,.map_svg__cls-4{fill:none;stroke:#000}.map_svg__cls-2{stroke-miterlimit:10;stroke-width:32px}.map_svg__cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:22.29px}"))), /*#__PURE__*/React.createElement("path", {
    d: "M261.3 244.24V831a43 43 0 0 0 43 43h419.51a43 43 0 0 0 43-43V125.48a43 43 0 0 0-43-43H423.34A43 43 0 0 0 393 95L274 213.76a43 43 0 0 0-12.7 30.48Z",
    style: {
      fill: "#f9a01f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__cls-2",
    d: "M204.3 244.24V831a43 43 0 0 0 43 43h476.51a43 43 0 0 0 43-43V125.48a43 43 0 0 0-43-43H366.34A43 43 0 0 0 336 95L217 213.76a43 43 0 0 0-12.7 30.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__cls-2",
    d: "M379.1 84.48v118.1a46.19 46.19 0 0 1-46.19 46.19H204.63"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "27.86px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#000"
    },
    d: "M464 326h199v128H464z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "map_svg__cls-4",
    cx: 336,
    cy: 704,
    r: 52
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "map_svg__cls-4",
    cx: 613,
    cy: 704,
    r: 52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__cls-4",
    d: "M427 417s-94 68-94 193c34-27 53-53 53-53M333 610l-50.5-50.5M415 701h115l-46.5-46.5M530 701l-44 44M625 610V495l-46.5 46.5M625 495l44 44"
  })));
};
export default SvgMap;